import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Image } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { CockpitMode, PermissionButton } from '@/utils/constant';
import './index.scss';
import { getPermissionById } from '@/utils';
interface option {
  value: CockpitMode;
  label: string;
  disable: boolean;
}
const SelectMode = ({
  curSelect,
  direction,
  getCurSelect,
}: {
  curSelect: CockpitMode;
  direction: 'up' | 'down';
  getCurSelect: (val: CockpitMode) => void;
}) => {
  const cockpitMode: option[] = [
    {
      value: CockpitMode.LISTENING_MODE,
      label: '听单模式',
      disable: !getPermissionById(PermissionButton.SPV_LISTENING_MODE),
    },
    {
      value: CockpitMode.WATCH_CAR_MODE,
      label: '盯车模式',
      disable: !getPermissionById(PermissionButton.SPV_WATCH_CAR_MODE),
    },
    {
      value: CockpitMode.PATROL_MODE,
      label: '巡查模式',
      disable: !getPermissionById(PermissionButton.SPV_PATROL_MODE),
    },
  ];

  const [dropdownInfo, setDropdownInfo] = useState({
    open: false,
    curSelectVal: curSelect,
    curSelectLabel: '',
  });

  useEffect(() => {
    setDropdownInfo({
      ...dropdownInfo,
      curSelectVal: curSelect,
      curSelectLabel: cockpitMode.find((item) => item.value === curSelect)!
        ?.label,
    });
  }, [curSelect]);

  const changeOpen = (e: any) => {
    e.stopPropagation();

    setDropdownInfo({
      ...dropdownInfo,
      open: !dropdownInfo.open,
    });
  };
  const handleSelect = (item: option) => {
    setDropdownInfo({
      open: false,
      curSelectVal: item.value,
      curSelectLabel: item.label,
    });
    getCurSelect && getCurSelect(item.value);
  };
  return (
    <div
      className={classNames('cockpit-mode-select', {
        click: dropdownInfo.open,
      })}
      onClick={(e) => changeOpen(e)}
    >
      {dropdownInfo.open && (
        <div
          className={classNames('dropdown-list', {
            up: direction === 'up',
            down: direction === 'down',
          })}
          onClick={(e) => e.stopPropagation()}
        >
          {cockpitMode.map((item: option) => {
            if (item.value !== dropdownInfo.curSelectVal && !item.disable) {
              return (
                <div
                  key={item.value}
                  className='option'
                  onClick={() => handleSelect(item)}
                >
                  {item.label}
                </div>
              );
            }
          })}
        </div>
      )}
      <span>{dropdownInfo.curSelectLabel}</span>
      <div
        className={classNames('icon', {
          click: dropdownInfo.open,
        })}
      >
        {direction === 'up' &&
          (dropdownInfo.open ? (
            <img
              src={require('../../../../assets/img/cockpit/down-icon.png')}
            />
          ) : (
            <img src={require('../../../../assets/img/cockpit/up-icon.png')} />
          ))}
        {direction === 'down' &&
          (dropdownInfo.open ? (
            <img src={require('../../../../assets/img/cockpit/up-icon.png')} />
          ) : (
            <img
              src={require('../../../../assets/img/cockpit/down-icon.png')}
            />
          ))}
      </div>
    </div>
  );
};

export default React.memo(SelectMode);
